module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', [_c('NowPlaying', {
    attrs: {
      "playing": _vm.playing
    }
  }), _vm._v(" "), _c('RadioStats', {
    attrs: {
      "repeatinfo": _vm.repeatInfo,
      "stats": _vm.radioStats
    }
  }), _vm._v(" "), _c('TrackList', {
    attrs: {
      "id": "recent",
      "header": "Recently Played",
      "tracks": _vm.recentlyPlayed,
      "skipfirst": true
    }
  }), _vm._v(" "), _c('TrackList', {
    attrs: {
      "id": "popular",
      "header": "Popular Tracks",
      "tracks": _vm.popularTracks,
      "longdate": true
    }
  })], 1) : _c('div', [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('span', {
    staticClass: "fa fa-spinner fa-spin fa-2x"
  }), _vm._v(" "), _c('h1', [_vm._v("Connecting to radio... please wait...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0980e43a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeView/index.vue
// module id = 270
// module chunks = 1